import { useQuery } from "@tanstack/react-query";
import { getCommunicationVehicles } from "../services";
import type {
	CommunicationListParams,
	CommunicationPaginatedResponse,
} from "../types";

export const COMMUNICATION_LIST_QUERY_KEY = "tracking-communication-list";

export function useCommunicationList(params: CommunicationListParams) {
	return useQuery<CommunicationPaginatedResponse>({
		queryKey: [COMMUNICATION_LIST_QUERY_KEY, params],
		queryFn: () => getCommunicationVehicles(params),
		enabled: params.pageNumber >= 1 && params.pageSize >= 1,
	});
}
